<template>
  <span ref="el" :class="{ 'd-inline-flex align-items-center': inline }">
    <font-awesome-icon
      icon="circle-info"
      :class="iconClasses"
      :style="{ color: iconColor, fontSize: iconSize }"
    />
  </span>
</template>

<script>
import { Popover as BootstrapPopover } from 'bootstrap';

export default {
  name: 'InfoPopover',
  props: {
    content: {
      type: String,
      required: false,
      default: '',
    },
    placement: {
      type: String,
      required: false,
      default: 'bottom',
    },
    trigger: {
      type: String,
      required: false,
      default: 'hover click focus',
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconColor: {
      type: String,
      required: false,
      default: '#0fb9b9',
    },
    iconSize: {
      type: String,
      required: false,
      default: '80%',
    },
    float: {
      type: String,
      required: false,
      default: 'end',
    },
    marginTop: {
      type: Number,
      required: false,
      default: 2,
    },
  },
  data() {
    return {
      el: null,
    };
  },
  computed: {
    iconClasses() {
      if (this.inline) return null;
      return [
        this.float === 'none' ? null : `float-${this.float}`,
        this.marginTop === 0 ? null : `mt-${this.marginTop}`,
      ];
    },
  },
  mounted() {
    if (this.content) {
      this.el = new BootstrapPopover(this.$refs.el, {
        container: 'body',
        html: true,
        trigger: this.trigger,
        placement: this.placement,
        content: this.content,
      });
    }
  },
  unmounted() {
    if (this.el) {
      this.el.dispose();
    }
  },
};
</script>
